<span class="status-icon" [ngClass]="isEnabled ? 'icon-small-check-circle' : 'icon-small-remove-circle'"></span>